import React, { useCallback, useEffect, useState } from "react";
import "./Topbar.css";
import { Avatar, Button, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setDraftModel,
  setGenerateModel,
} from "../../service/apiSlices/staticApi";
import { RootState } from "../../service/store";
import { useTranslation } from "react-i18next";
import { setInviteWorkbenchUserModal } from "../../service/apiSlices/staticApi";
import InviteTeamWorkbenchModal from "../InviteTeamWorkbench/InviteTeamWorkbenchModal";
import { useGetWorkBenchPermissionsQuery } from "../../service/apiSlices/workbench";
import { getAvatarColor } from "../../utilities/utils";
import ViewPortZoomInput from "./ViewPortZoomInput";
import ViewPortThemeChanger from "./ViewPortThemeChanger";
import { useModelDetailsContext } from "../../context/workbench/ModelDetailsContex";
import ContextModal from "./ContextModal";
import PendingStatusModal from "../dashboard/DashboardMain/DashboardModelsCard/PendingStatusModal";
import { GeneratedModelTypes } from "../../utilities/types/ModelsTypes";
import { useGetRedirectionURLMutation } from "../../service/apiSlices/dashboard";
import { usePermission } from "../../hooks/usePermission";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utilities/Constants/Constants";


const Topbar = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const secret_key = sessionStorage.getItem('secret_key');
  const { setIsGenerateModelContextOpen, setIsPendingStatusModalOpen, isPendingStatusModalOpen, isGenerateModelContextOpen } = useModelDetailsContext();
  const [selectedModel, setSelectedModel] = useState<any>(null);
  const [getChatURL] = useGetRedirectionURLMutation();
  const workBenchName = useSelector(
    (state: RootState) => state?.static?.workBenchName
  );

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage({ type: 'message-ready' }, window.location.origin);
    }
    const handleMessage = (event: any) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.model) {
        setSelectedModel(event.data.model);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  // useEffect(() => {
  //   if (selectedModel === null) {
  //     const customModel = {
  //       secret_key: sessionStorage.getItem("secret_key") || "",
  //       id: sessionStorage.getItem("id") || "",
  //       is_model_completed: false,
  //       filename: "Status",
  //       isCustomModel: true,
  //     }
  //     setSelectedModel(customModel);
  //   }
  // }, []);

  const handleConfirmGenerateModel = useCallback(() => {
    dispatch(setGenerateModel(true));
  }
    , [dispatch]);

  const handleModalClose = () => {
    // setIsPendingStatusModalOpen(false);
  };

  const generateChatLink = (key: any) => {
    getChatURL({ key }).unwrap().then((response: any) => {
      if (response?.data) {
        window.open(response.data, "_blank");
      }
    });
  };

  const handleAllStatusCompleted = (id: string | number, data: GeneratedModelTypes) => {
    setTimeout(() => {
      setIsPendingStatusModalOpen(false);
      generateChatLink(data.secret_key || secret_key);
    }, 3000);
  };

  const isInviteWorkbenchModalOpen = useSelector((state: RootState) => state?.static.inviteWorkbenchUserModal);
  const modelTypeFromWorkbench = useSelector((state: RootState) => state?.static.modelTypeFromWorkbench);
  const { canView, canEdit } = usePermission();
  const { data: getWorkBenchPermissions } = useGetWorkBenchPermissionsQuery(secret_key);
  const handleClose = useCallback(() => {
    dispatch(setInviteWorkbenchUserModal(false));
  }, [dispatch]);


  return (
    <>
      <div className="workbench-topbar">
        <div className="d-flex align-items-center gap-3">
          <div className="zoom-input-wrapper">
            <ViewPortZoomInput />
          </div>
          <div className="color-section">
            {secret_key && modelTypeFromWorkbench === "viewport" && canView && canEdit && (
              <ViewPortThemeChanger />
            )}
          </div>
        </div>
        <div className="d-flex gap-3">
          <div className="">
            <Avatar.Group
              size="default"
              max={{
                count: 3,
                style: { color: "#f56a00", backgroundColor: "#fde3cf" },
              }}
            >
              {getWorkBenchPermissions?.data?.map(
                (item: any, index: number) => (
                  <Tooltip key={index} title={item?.email} placement="top">
                    <Avatar
                      icon={
                        item?.profile_image ? (
                          <img src={item?.profile_image} alt="user" />
                        ) : null
                      }
                      style={{ backgroundColor: getAvatarColor(item?.email) }}
                    >
                      {item?.email[0].toUpperCase()}
                    </Avatar>
                  </Tooltip>
                )
              )}
            </Avatar.Group>
          </div>
          {secret_key && modelTypeFromWorkbench === "viewport" && canView && canEdit && (
            <Button
              className="top-bar-invite-btn"
              disabled={workBenchName === ""}
              onClick={() => dispatch(setInviteWorkbenchUserModal(true))}
            >
              {t("inviteTeamModal.buttonText")}
            </Button>
          )}
          <div className={`${canEdit && canView ? "applyBorder" : ""} save-deploy-buttons`}>
            {canView && canEdit && (
              <Button
                className="draft-button"
                onClick={() => dispatch(setDraftModel(true))}
              >
                {t("buttons.saveAsDraft")}
              </Button>
            )}
            {canView && canEdit && (

              < Button
                className="generate-model-button"
                onClick={() => dispatch(setGenerateModel(true))}
              >
                {t("buttons.generateModel")}
              </Button>
            )}

          </div>
        </div>
      </div>
      <ContextModal
        visible={isGenerateModelContextOpen}
        onConfirm={handleConfirmGenerateModel}
        onCancel={() => setIsGenerateModelContextOpen(false)}
        title={t('contextModal.title')}
        content={""}
        okText={t('buttons.confirm')}
        cancelText={t('buttons.cancel')}
      />


      {
        selectedModel && isPendingStatusModalOpen &&
        <PendingStatusModal
          model={selectedModel}
          isVisible={isPendingStatusModalOpen}
          handleOnChange={handleModalClose}
          onAllStatusCompleted={handleAllStatusCompleted}
        />
      }

      <InviteTeamWorkbenchModal
        visible={isInviteWorkbenchModalOpen}
        onClose={handleClose}
      />
    </>
  );
};

export default React.memo(Topbar);
